import { LoginService } from './../../../../../core/services/login.service';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Filter } from 'src/app/core/models/filter';
import { combineLatest } from 'rxjs';
import { pluck } from 'rxjs/operators';
const secondHandSuppliesOrdersSubscription = gql`query second_hand_supplies_orders(
  $andList: [second_hand_supplies_orders_bool_exp!],
  $sortList: [second_hand_supplies_orders_order_by!],
  $limit: Int, $offset: Int) {
  second_hand_supplies_orders(
    where: {_and: $andList},
    order_by: $sortList,
    limit: $limit,
    offset: $offset) {
    id
    created_at
    updated_at
    short_id
    total_amount
    tax_amount
    delivery_charge
    estimated_delivery_in_days
    status
    payment_status
    payment_mode
    billing_address
    shipping_address
    online_payment_order_id
    online_payment_transaction_id
    online_payment_signature
    approved_on
    approved_message
    shipped_on
    shipped_message
    delivered_on
    delivered_message
    cancelled_on
    canceled_message
    refunded_on
    refunded_message
    custom_message
    payment_intent
    dental_practice_id
    dental_practice {
      id
      name
      email
      phone
    }
    dental_professional_id
    dental_professional {
      id
      name
      email
      phone
    }
    dental_supplier_id
    dental_supplier {
      id
      name
      email
      phone
    }
    account_pay_details
    suppliers_id
    sub_total
    order_number
    invoice
    second_hand_supply_id
    second_hand_supply {
      id
      dental_supplier_id
      dental_supplier {
        id
        name
        business_name
      }
      dental_practice_id
      dental_practice{
        id
        name
      }
      dental_professional_id
      dental_professional{
        id
        name
      }
    }
    second_hand_supplies_order_notes{
      id
      created_at
      updated_at
      second_hand_supplies_order_id
      status
      message
      extra
    }
    refunds{
      id
      created_at
      updated_at
      payment_intent_id
      supply_order_id
      refund_payload
      refund_status
      amount
      second_hand_supplies_order_id
    }
  }
}`;

const secondHandSuppliesOrdersAggregateSubscription = gql`query second_hand_supplies_orders_aggregate($andList: [second_hand_supplies_orders_bool_exp!]){
  second_hand_supplies_orders_aggregate(where:{_and: $andList}) {
    aggregate {
      count
    }
  }
}`;
const secondHandSuppliesOrdersStatusWiseCountQuery = gql`query second_hand_supplies_orders_aggregate_status_wise{
  pending: second_hand_supplies_orders_aggregate(where:{status:{_eq: "PENDING"}}){
    aggregate{
      count
    }
  }
  approved: second_hand_supplies_orders_aggregate(where:{status:{_eq: "APPROVED"}}){
    aggregate{
      count
    }
  }
  shipped: second_hand_supplies_orders_aggregate(where:{status:{_eq:"SHIPPED"}}){
    aggregate{
      count
    }
  }
  delivered: second_hand_supplies_orders_aggregate(where: {status:{_eq:"DELIVERED"}}){
    aggregate {
      count
    }
  }
  cancelled: second_hand_supplies_orders_aggregate(where: {status:{_eq:"CANCELLED"}}){
    aggregate {
      count
    }
  }
  refunded: second_hand_supplies_orders_aggregate(where: {status:{_eq:"REFUNDED"}}){
    aggregate {
      count
    }
  }
}`;

const secondHandSuppliesOrdersUserStatusWiseCountQuery = gql`query second_hand_supplies_orders_aggregate_status_wise(
  $user_id: uuid){
  pending: second_hand_supplies_orders_aggregate(where:{status:{_eq: "PENDING"},
    second_hand_supply: {
      _or: [{
       dental_practice_id: {_eq: $user_id}
     },{
       dental_professional_id: {_eq: $user_id}
     },{
       dental_supplier_id: {_eq: $user_id}
     }]
     }
}){
    aggregate{
      count
    }
  }
  approved: second_hand_supplies_orders_aggregate(where:{status:{_eq: "APPROVED"},
  second_hand_supply: {
    _or: [{
     dental_practice_id: {_eq: $user_id}
   },{
     dental_professional_id: {_eq: $user_id}
   },{
     dental_supplier_id: {_eq: $user_id}
   }]
   }


  }){
    aggregate{
      count
    }
  }
  shipped: second_hand_supplies_orders_aggregate(where:{status:{_eq:"SHIPPED"},
  second_hand_supply: {
    _or: [{
     dental_practice_id: {_eq: $user_id}
   },{
     dental_professional_id: {_eq: $user_id}
   },{
     dental_supplier_id: {_eq: $user_id}
   }]
   }
}){
    aggregate{
      count
    }
  }
  delivered: second_hand_supplies_orders_aggregate(where: {status:{_eq:"DELIVERED"},

  second_hand_supply: {
    _or: [{
     dental_practice_id: {_eq: $user_id}
   },{
     dental_professional_id: {_eq: $user_id}
   },{
     dental_supplier_id: {_eq: $user_id}
   }]
   }

}

  ){
    aggregate {
      count
    }
  }
  cancelled: second_hand_supplies_orders_aggregate(where: {status:{_eq:"CANCELLED"},
  second_hand_supply: {
    _or: [{
     dental_practice_id: {_eq: $user_id}
   },{
     dental_professional_id: {_eq: $user_id}
   },{
     dental_supplier_id: {_eq: $user_id}
   }]
   }

}){
    aggregate {
      count
    }
  }
  refunded: second_hand_supplies_orders_aggregate(where: {status:{_eq:"REFUNDED"},
  second_hand_supply: {
    _or: [{
     dental_practice_id: {_eq: $user_id}
   },{
     dental_professional_id: {_eq: $user_id}
   },{
     dental_supplier_id: {_eq: $user_id}
   }]
   }
}){
    aggregate {
      count
    }
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSecondHandOrdersService {

/* ------------------------------- Constructor ------------------------------ */
  constructor(
  private apollo: Apollo,
  private loginService: LoginService) { }

/* ------------------------------- Get Supply Orders ------------------------------- */
getSecondHandSuppliesOrders(filter: Filter){
  const andList: any =  [{
    status: {"_eq": filter.status}
   }];
   if(filter.search){
    andList.push({
      order_number: { _eq: filter.search }
    })
   }
   const loginData = this.loginService.getLoginData();
  if(['SUPPLIER', 'PRACTICE', 'PROFESSIONAL'].includes(loginData.type)){
      andList.push({
        second_hand_supply: {
        _or: [{
          dental_practice_id: {_eq: loginData.id}
        },{
          dental_professional_id: {_eq: loginData.id}
        },{
          dental_supplier_id: {_eq: loginData.id}
        }]
      }
      })
  }
   const filters: any = filter.filters.filter(single=>{
     return single.value && single.operator && single.value
   }).map(single=>{
    const columnParts = single.column.column.split(".");
    if(single.column.column === 'customer_name'){
     return {
        _or:[{
          dental_supplier: {
            name :  {
             [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
           }
          }
        },{
          dental_practice: {
            name :  {
             [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
           }
          }
        },{
          dental_professional: {
            name :  {
             [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
           }
          }
        }]
      }
    }
    else if(single.column.column === 'customer_email'){
      return {
         _or:[{
           dental_supplier: {
             email :  {
              [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
            }
           }
         },{
           dental_practice: {
             email :  {
              [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
            }
           }
         },{
           dental_professional: {
             email :  {
              [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
            }
           }
         }]
       }
     }
     else if(single.column.column === 'customer_phone'){
      return {
         _or:[{
           dental_supplier: {
             phone :  {
              [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
            }
           }
         },{
           dental_practice: {
             phone :  {
              [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
            }
           }
         },{
           dental_professional: {
             phone :  {
              [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
            }
           }
         }]
       }
     }
    else if(columnParts.length === 1){
      return {
        [single.column.column] :  {
         [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
       }
      }
    } else {
      return { [columnParts[0]] : {
        [columnParts[1]] :  {
         [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
       }
      }}
    }

  });

  const finalArray = andList.concat(filters);
  return combineLatest([
    this.apollo.use('external').query({
     query: secondHandSuppliesOrdersSubscription,
     fetchPolicy: "network-only",
     variables: {
       andList: finalArray,
       sortList: [filter.sort],
       limit: filter.limit,
       offset: filter.offset
     }
    }).pipe(pluck('data', 'second_hand_supplies_orders')),

    this.apollo.use('external').query({
      query: secondHandSuppliesOrdersAggregateSubscription,
      fetchPolicy: "network-only",
      variables: {
        andList: finalArray,
        sortList: [filter.sort],
      }
    }).pipe(pluck('data', 'second_hand_supplies_orders_aggregate', 'aggregate', 'count')),

    ['PRACTICE','PROFESSIONAL', 'SUPPLIER'].includes(loginData.type)
    ?
    this.apollo.use('external').query({
      query: secondHandSuppliesOrdersUserStatusWiseCountQuery,
      variables:{
        user_id: loginData.id
      },
      fetchPolicy: "network-only"
    }).pipe(pluck("data"))
    :
    this.apollo.use('external').query({
      query: secondHandSuppliesOrdersStatusWiseCountQuery,
      fetchPolicy: "network-only"
    }).pipe(pluck("data"))

  ]);
}
}
